export default __webpack_public_path__ + "static/photo_3-8ff66c621360f1a262d2b230fc8369c9.jpg";